import { GeoJSON } from 'geojson';
export const createIconImage = (canvas: HTMLCanvasElement, iconName: string): Promise<ImageData> => {
    return new Promise((resolve, reject) => {
      var ctx = canvas.getContext('2d')
      var image = new Image(48, 48)
      image.onload = () => {
        var iconWidth = 32
        var iconHeight = 32
        var width = 48
        var height = 48
        var centerX = width / 2
        var centerY = height / 2
        var radius = 20
        ctx!.beginPath()
        ctx!.arc(centerX, centerY, radius, 0, 2 * Math.PI, false)
        ctx!.fillStyle = '#ffb300'
        ctx!.fill()
        // use data from svg?
        var sx = centerX- iconWidth  / 2
        var sy = centerY - iconHeight / 2
        var swidth = iconWidth
        var sheight = iconHeight

        ctx!.drawImage(image, sx,sy, swidth, sheight)
        var imageData = ctx!.getImageData(0, 0, canvas.width, canvas.height)
        resolve(imageData)
        // this.map.addImage(iconName, imageData)
      }
      image.src = `assets/icons/${iconName}.svg`
    })
  }

export const isFeatureEmpty = (featureCollection: GeoJSON.FeatureCollection): boolean => {
  if (!featureCollection?.features?.length) return true;

  return featureCollection.features.every((feature:any) => {
    const geometry = feature.geometry as any;

    if (!geometry) { return true; }
    if (!geometry?.coordinates) { return true; }
    if (geometry.type === 'GeometryCollection') {
      return !geometry.geometries?.length;
    }

    return !geometry.coordinates
      .flat(Infinity)
      .some((value: any) => typeof value === 'number' && !Number.isNaN(value));
  });

}